import SpotlightModule from './Spotlight.module';

export default SpotlightModule;
